// extracted by mini-css-extract-plugin
export var badge = "PreviewOverlay-module--badge--5e557";
export var button = "PreviewOverlay-module--button--0f740";
export var indicator = "PreviewOverlay-module--indicator--cec76";
export var logo = "PreviewOverlay-module--logo--21ddc";
export var previewOverlay = "PreviewOverlay-module--previewOverlay--f410e";
export var tooltip = "PreviewOverlay-module--tooltip--46032";
export var tooltipText = "PreviewOverlay-module--tooltipText--3b8ef";